export const SALES_RETURN_REGISTER_REPORT_REQUEST = 'SALES_RETURN_REGISTER_REPORT_REQUEST';
export const SALES_RETURN_REGISTER_REPORT_SUCCESS = 'SALES_RETURN_REGISTER_REPORT_SUCCESS';
export const SALES_RETURN_REGISTER_REPORT_FAILURE = 'SALES_RETURN_REGISTER_REPORT_FAILURE';